import { css } from '@emotion/core';
import { paginatorLargeBreakpoint } from './variables';
import { generateColors } from './global';
export var container = isSmall => /*#__PURE__*/css("display:flex;align-items:center;justify-content:center;margin:0 auto;min-width:230px;max-width:300px;", !isSmall && /*#__PURE__*/css("@media (min-width:", paginatorLargeBreakpoint, "){max-width:450px;}"));
export var spacer = /*#__PURE__*/css(generateColors('default'), " border-width:var(--paginator-border-width) 0;border-style:solid;width:40px;text-align:center;line-height:2;");
export var pagesContainer = {
  name: "1xwm3ah",
  styles: "display:flex;flex-wrap:nowrap;justify-content:center;border-radius:var(--paginator-border-radius);"
};